module.exports = __webpack_public_path__ + "cfpModelSettingsCarousel.1e077aa3ea028ca965b8ece279e1f5e6.png";